import React from "react";
import View from "../../view/game/game";

const Presenter: React.FC = () => {
    return <View/>
};

export default Presenter;